import { observer } from 'mobx-react';
import State from '../../../store/State';
import styles from './CountryItem.module.css'
import { content } from '../../../types/enums';
import playDesktop from '../../../assets/images/play-desktop.svg'
import playMobile from '../../../assets/images/play-mobile.svg'

interface ICountryItemProps {
  img: string;
  name: string;
  index: number;
}

export const CountryItem = observer(({ img, name, index }: ICountryItemProps) => {
  const clickHandler = () => {
    if (State.getActiveCountryIndex() === index) State.setActiveCountryIndex(content.NO)
    else State.setActiveCountryIndex(index)
  }

  return (
    <div className={styles.country} onClick={clickHandler}>
      <img src={img} alt={'countrybg'} className={styles.img} />
      <div className={styles.content}>
        <p className={styles.name}>{name}</p>
        <div className={styles.play}>
          <img src={playDesktop} alt='' className={styles.play_desktop} />
          <img src={playMobile} alt='' className={styles.play_mobile} />
        </div>
      </div>
    </div>
  )
});

export default CountryItem
